const apiRoute: string = '/api';

export const useApi = async (url: string, options?: any) => {
    const headers: HeadersInit = {
        Accept: "application/json",
        'Cache-Control': 'no-cache',
        'X-Requested-With': 'XMLHttpRequest', // This header is needed in .NET to run the method IsAjaxRexuest.
        ...options?.headers
    };

    const opts: any = options ? (({ headers, ...opts }) => opts)(options) : null;
    const baseURL = !options?.baseURL ? apiRoute : options.baseURL;
    url = `${baseURL}${url}`;

    return await $fetch(url, { ...opts, ...{ headers } });
};

export const useApiData = (
    key: string,
    url: string | Function,
    dataOptions?: any,
    fetchOptions?: any) => useAsyncData(key, async () => {
        dataOptions = dataOptions ?? {};
        fetchOptions = fetchOptions ?? {};
        const { $i18n }: any = useNuxtApp();

        console.log(typeof url === 'function' ? url() : url);

        let responseHeaders: Headers | null = null;
        let statusCode: number | null = null;

        if (fetchOptions.body) {
            fetchOptions.body = typeof fetchOptions.body === 'function' ? fetchOptions.body() : fetchOptions.body;
        }

        try {
            // TODO: We are diong a interpolation. This should be done in useApi.
            const data = await useApi(`/${$i18n.locale.value}${typeof url === 'function' ? url() : url}`, {
                ...fetchOptions,
                onResponse({ response }) {
                    responseHeaders = response.headers;
                    statusCode = response.status;
                }
            });

            return {
                status: statusCode,
                isError: false,
                payload: data,
                messages: {
                    status: responseHeaders?.get('x-status-message') || null,
                }
            };
        } catch (error: any) {
            console.log(error)
            return {
                status: statusCode,
                isError: true,
                payload: null,
                messages: {
                    status: responseHeaders?.get('x-status-message') || null,
                }
            };
        }
    }, dataOptions);

export const useApiRaw = async (url: string, options?: any) => {
    const headers: HeadersInit = {
        Accept: "application/json",
        'Cache-Control': 'no-cache',
        'X-Requested-With': 'XMLHttpRequest', // This header is needed in .NET to run the method IsAjaxRexuest.
        ...options?.headers
    };

    const opts: any = options ? (({ headers, ...opts }) => opts)(options) : null;
    const baseURL = !options?.baseURL ? apiRoute : options.baseURL;
    url = `${baseURL}${url}`;

    return await $fetch.raw(url, { ...opts, ...{ headers } });
};

export const useApiFetch = async (url: string | (() => string), options?: any) => {
    const { $i18n }: any = useNuxtApp();

    const headers: HeadersInit = {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest', // This header is needed in .NET to run the method IsAjaxRexuest.
        ...options?.headers,
    };

    var options = {
        immediate: false,
        watch: false,
        cache: 'no-cache',
        getCachedData: () => null,
        ...options
    }

    const opts: any = options ? (({ headers, ...opts }) => opts)(options) : null;
    const baseURL = !options?.baseURL ? apiRoute : options.baseURL;

    return useFetch(() => `${baseURL}/${$i18n.locale.value}${typeof url === 'function' ? url() : url}`, { ...opts, ...{ headers } });
};

export const useApiFetchX = (url: string | (() => string), initialOptions?: any) => {
    const { $i18n }: any = useNuxtApp();

    const data = ref(null);
    const error = ref<Error | null>(null);
    const pending = ref(false);
    const responseHeaders = ref<Headers | null>(null);
    const statusCode = ref<number | null>(null);
    const isError = ref(false);

    const options = ref({
        method: 'GET',
        baseURL: apiRoute,
        headers: {
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest', // This header is needed in .NET to run the method IsAjaxRexuest.
        },
        body: undefined,
        ...initialOptions,
    });

    const fetchUrl = computed(() =>
        `${options.value.baseURL}/${$i18n.locale.value}${typeof url === 'function' ? url() : url}`
    );

    const execute = async (eo?: any) => {
        pending.value = true;
        error.value = null;

        const ro = {
            ...options.value,
            ...eo
        };

        try {
            let body = typeof ro.body === 'function'
                ? ro.body()
                : ro.body;
            const urlAppend = (typeof ro.url === 'function'
                ? ro.url()
                : ro.url ?? '');
            const path = `${fetchUrl.value}${urlAppend}`.toString();

            if (body instanceof FormData) {
                // No need to set content type.
            } else if (body) {
                ro.headers['Content-Type'] = 'application/json';
                body = JSON.stringify(body);
            }

            const response = await fetch(path, {
                method: ro.method,
                headers: {
                    Accept: 'application/json',
                    'X-Requested-With': 'XMLHttpRequest',
                    ...ro.headers,
                },
                body: body,
                cache: ro.cache ?? 'no-cache',
            });

            responseHeaders.value = response.headers;
            statusCode.value = response.status;
            isError.value = !response.ok;

            let json = null;

            try {
                json = await response.json();
            } catch {

            } 

            data.value = {
                ok: response.ok,
                status: statusCode.value,
                isError: isError.value,
                payload: isError.value ? null : json,
                messages: {
                    status: responseHeaders.value?.get('x-status-message') || null,
                },
            };
        } catch (err: any) {
            error.value = err;
            isError.value = true;
        } finally {
            pending.value = false;
        }

        return {
            ok: data.value?.ok,
            payload: data.value?.payload
        }
    };

    return {
        data,
        error,
        pending,
        execute,
        options,
        isError,
        statusCode,
        responseHeaders,
    };
};

export const useApiFetchWrap = (url: string | (() => string), initialOptions?: any) => {
    return reactive(useApiFetchX(url, initialOptions));
}

